import type { Config } from 'effect';
import type {
  ImageFallbackSource,
  ImagesWithFallbackFor,
  ImagesWithFallbackForAllKeys,
  ImageWithFallback,
} from '../type/imagePath';

import { Effect, Option, Record } from 'effect';

import { getImageBackendFallback } from '@vs-shop/engine/image/getImageBackendFallback';

export function getImageWithFallback(
  src: ImageFallbackSource
): Effect.Effect<ImageWithFallback, Config.ConfigError> {
  return Effect.gen(function* () {
    const primary = src;

    return yield* Option.match(primary, {
      onNone: () =>
        Effect.succeed<ImageWithFallback>({
          primary,
          backendFallback: Option.none(),
        }),
      onSome: (path) =>
        getImageBackendFallback(path).pipe(
          Effect.map((backendFallback) => ({ primary, backendFallback }))
        ),
    });
  });
}

export function getImagesWithFallback<const Sources extends ImagesWithFallbackForAllKeys>(
  sources: Sources
): Effect.Effect<ImagesWithFallbackFor<Sources>, Config.ConfigError>;

export function getImagesWithFallback(sources: ImagesWithFallbackForAllKeys) {
  return Effect.all(Record.map(sources, getImageWithFallback));
}
